import { create as axiosCreate } from 'axios';
import qs from 'qs';

import { getCsrfToken, getGlobalParam } from '@agilemd/ui-utils';

import generateInterceptors from './interceptors/index.js';

const JWT_TOKEN = getGlobalParam('sessionJsonWebToken', null) || undefined;

/**
 * Generates an axios instance
 * @param {{baseURL: string}} options
 */
export default function generateAxiosInstance({ baseURL }) {
  const axiosInstance = axiosCreate({
    headers: {
      post: { 'Content-Type': 'application/json' },
      put: { 'Content-Type': 'application/json' },
      Accept: 'application/json',
      'X-CSRF-Token': getCsrfToken()
    },
    baseURL,
    xsrfHeaderName: 'X-CSRF-TOKEN',
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'comma' }),
    params: {
      jwt: JWT_TOKEN
    }
  });

  return { axios: axiosInstance, interceptors: generateInterceptors(axiosInstance) };
}
